import i18n from '../i18n'
import React from 'react'
import { Dropdown } from 'semantic-ui-react'

export const currencyOptions = [
  { key: 'CLP', value: 'CLP', flag: 'cl', get text() { return i18n.t('finance:currencyNames.CLP', { defaultValue: 'Pesos' }) } },
  { key: 'USD', value: 'USD', flag: 'us', get text() { return i18n.t('finance:currencyNames.USD', { defaultValue: 'Dólar' }) } },
  { key: 'EUR', value: 'EUR', flag: 'eu', get text() { return i18n.t('finance:currencyNames.EUR', { defaultValue: 'Euro' }) } },
  //{ key: 'GBP', value: 'GBP', flag: 'gb', get text() { return i18n.t('finance:currencyNames.GBP', { defaultValue: 'Libra' }) } },
  //{ key: 'MXN', value: 'MXN', flag: 'mx', get text() { return i18n.t('finance:currencyNames.MXN', { defaultValue: 'Pesos' }) } },
]

export const currencyOptionsWithSpecials = [
  { key: 'CLP', value: 'CLP', flag: 'cl', get text() { return i18n.t('finance:currencyNames.CLP', { defaultValue: 'Pesos' }) }, prefix: '$', separation: '.', decimals: 0, round:false },
  { key: 'UF', value: 'UF', flag: 'cl', get text() { return i18n.t('finance:currencyNames.UF', { defaultValue: 'UF' }) }, prefix: 'UF', separation: ',', decimals: 2, round: true },
  { key: 'USD', value: 'USD', flag: 'us', get text() { return i18n.t('finance:currencyNames.USD', { defaultValue: 'Dólar' }) }, prefix: 'US$', separation: '.', decimals: 2, round: true },
  { key: 'EUR', value: 'EUR', flag: 'eu', get text() { return i18n.t('finance:currencyNames.EUR', { defaultValue: 'Euro' }) }, prefix: '€', separation: '.', decimals: 2, round: true },
  { key: 'UTM', value: 'UTM', flag: 'cl', get text() { return i18n.t('finance:currencyNames.UTM', { defaultValue: 'UTM' }) }, prefix: 'UTM', separation: ',', decimals: 2, round: true },
  { key: 'ARS', value: 'ARS', flag: 'ar', get text() { return i18n.t('finance:currencyNames.ARS', { defaultValue: 'Peso Argentino' }) }, prefix: '$', separation: '.', decimals: 2, round: true },
  { key: 'CNY', value: 'CNY', flag: 'cn', get text() { return i18n.t('finance:currencyNames.CNY', { defaultValue: 'Yuan' }) }, prefix: '¥', separation: '.', decimals: 2, round: true },
  { key: 'JPY', value: 'JPY', flag: 'jp', get text() { return i18n.t('finance:currencyNames.JPY', { defaultValue: 'Yen' }) }, prefix: '¥', separation: '.', decimals: 0, round: true },
  { key: 'PEN', value: 'PEN', flag: 'pe', get text() { return i18n.t('finance:currencyNames.PEN', { defaultValue: 'Sol' }) }, prefix: 'S/', separation: '.', decimals: 2, round: true },
  { key: 'BRL', value: 'BRL', flag: 'br', get text() { return i18n.t('finance:currencyNames.BRL', { defaultValue: 'Real' }) }, prefix: 'R$', separation: ',', decimals: 2, round: true },
  { key: 'COP', value: 'COP', flag: 'co', get text() { return i18n.t('finance:currencyNames.COP', { defaultValue: 'Peso Colombiano' }) }, prefix: '$', separation: '.', decimals: 0, round: false },
  { key: 'CAD', value: 'CAD', flag: 'ca', get text() { return i18n.t('finance:currencyNames.CAD', { defaultValue: 'Dólar Canadiense' }) }, prefix: 'C$', separation: '.', decimals: 2, round: true },
  { key: 'GBP', value: 'GBP', flag: 'gb', get text() { return i18n.t('finance:currencyNames.GBP', { defaultValue: 'Libra' }) }, prefix: '£', separation: '.', decimals: 2, round: true },
  { key: 'MXN', value: 'MXN', flag: 'mx', get text() { return i18n.t('finance:currencyNames.MXN', { defaultValue: 'Peso Mexicano' }) }, prefix: '$', separation: '.', decimals: 2, round: true },
  { key: 'UYU', value: 'UYU', flag: 'uy', get text() { return i18n.t('finance:currencyNames.UYU', { defaultValue: 'Peso Uruguayo' }) }, prefix: '$U', separation: '.', decimals: 2, round: true },
]

export const CurrenciesDropdown = ({
  style = {},
  onChange = () => { },
  onBlur = () => { },
  className = '',
  id = 'currency',
  name = 'currency',
  placeholder = 'Seleccione Moneda...',
  multiple = false,
  clearable = true,
  value = '',
}) => {
  return (
    <Dropdown
      selectOnBlur={false}
      className={className}
      multiple={multiple}
      style={{ ...style }}
      placeholder={placeholder}
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      options={currencyOptions}
      onBlur={onBlur}
      clearable={clearable}
      selection
      search
      button basic floating
      fluid
    />
  )
}
